import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { isDefined } from '../../../utils/variables';
import { GeodataSetupState } from '../../state/geodata-setup-state';
import { ProjectSpatialReferenceContext } from '../../state/project-reference-state';
import { Button } from '../button/button';
import { InfoBox } from '../info-box/info-box';
import { Projection } from '../project-settings/projection';
import { Stack } from '../stack/stack';
import { GeodataSetup } from './geodata-setup/geodata-setup';
import { GeodataSetupFooterButtons } from './geodata-setup/geodata-setup-footer-buttons';

export const GeodataUpload = () => {
  const { coordinateSystem } = useContext(ProjectSpatialReferenceContext);
  const [isCoordinateSystemSet, setIsCoordinateSystemSet] = useState(isDefined(coordinateSystem));
  const { t: translate } = useTranslation();

  if (!isCoordinateSystemSet) {
    return (
      <Stack direction="column" spacing={1}>
        <InfoBox color="yellow">
          {translate('geodataPage.coordinateSystemRequired.message', { ns: 'cloudProcessing' })}
        </InfoBox>
        <Projection />
        <Button
          color="primary"
          disabled={!coordinateSystem}
          variant="contained"
          width="fit-content"
          onClick={() => setIsCoordinateSystemSet(true)}
        >
          {translate('confirm', { ns: 'common' })}
        </Button>
      </Stack>
    );
  }

  return (
    <GeodataSetupState>
      <Component>
        <Stack direction="column" height={'100%'} spacing={2}>
          <Content>
            <GeodataSetup disableInteractiveSetup={true} height="100%" />
          </Content>
          <Stack direction="row" justifyContent="flex-end" spacing={1}>
            <GeodataSetupFooterButtons />
          </Stack>
        </Stack>
      </Component>
    </GeodataSetupState>
  );
};

const Component = styled.div`
  width: 100%;
  height: 100%;
  padding: 2em;
  background-color: white;
`;

const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`;
